module.exports = __webpack_public_path__ + "static/media/homemade-02.c17f4223.webm";